<template>
  <div class="fldy-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="操作时间">
              <el-date-picker
                v-model="searchForm.opertime"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="exportLoading" plain @click="exportExcel">导出Excel</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-plus" type="primary" @click="editRow(null)">添加原材料台账</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%"
                >
                  <el-table-column
                    label="月份"
                    width="60"
                    align="center"
                    fixed
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.month }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="周次"
                    width="60"
                    align="center"
                    fixed
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.week }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单号"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.ordernum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.produnum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="检验日期"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.testtime }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="供应商"
                    width="160"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.supplier }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="产品名称"
                    min-width="160"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="规格/型号"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.spec }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="单位"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.unit }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="类别"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.type }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="来料数量"
                    width="80"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.incomnum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="检验数量"
                    width="80"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.testnum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="合格数量"
                    width="80"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.passnum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="合格率"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#67C23A">{{ scope.row.passrate }}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="检验方式"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.testtype===0">全检</span>
                      <span v-if="scope.row.testtype===1">抽检</span>
                      <span v-if="scope.row.testtype===2">免检</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="问题描述"
                    width="240"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.desc }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="问题处理"
                    width="240"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.deal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="备注"
                    width="240"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.remark }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="添加时间"
                    width="170"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="判定"
                    width="80"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.deter===1" :disable-transitions="true" size="mini" type="success">合格</el-tag>
                      <el-tag v-if="scope.row.deter===0" :disable-transitions="true" size="mini" type="danger">不合格</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="200"
                    fixed="right"
                    align="center"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button size="mini" @click="editRow(scope.row)"><i class="el-icon-edit"></i> 编辑</el-button>
                      <el-button size="mini" :loading="deleteLoading" @click="deleteRow(scope.row)"><i class="el-icon-delete"></i> 删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>
              </el-col>
            </el-row>
          </div>
          <el-dialog
            :title="editTitle"
            :visible.sync="dialogVisible"
            width="800px"
            top="10vh"
            :destroy-on-close="true"
            :lock-scroll="true"
            :append-to-body="true"
          >
            <div v-loading="editFormLoading">
              <el-form ref="editForm" size="small" :model="editForm" label-width="80px" style="padding:15px 30px 15px 15px;" :rules="editRules">
                <el-form-item label="检验日期" prop="testtime">
                  <el-date-picker
                    v-model="editForm.testtime"
                    format="yyyy年MM月dd日"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="选择订单" prop="orderid">
                  <OrderChoose :key="num" v-model="editForm.orderid" :oldorderid="editForm.oldorderid" :mark="13"></OrderChoose>
                </el-form-item>
                <el-form-item label="供应商" prop="supplier">
                  <el-input v-model="editForm.supplier" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="产品名称" prop="name">
                  <el-input v-model="editForm.name" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="规格/型号" prop="spec">
                  <el-input v-model="editForm.spec" maxlength="200"></el-input>
                </el-form-item>
                <el-form-item label="单位" prop="unit">
                  <el-input v-model="editForm.unit" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="类别" prop="type">
                  <el-select v-model="editForm.type" placeholder="请选择">
                    <el-option
                      v-for="item in rawTypes"
                      :key="item.rtid"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="来料数量" prop="incomnum">
                  <el-input-number v-model="editForm.incomnum" :precision="2" :min="0" @change="calculatePass"></el-input-number>
                </el-form-item>
                <el-form-item label="检验数量" prop="testnum">
                  <el-input-number v-model="editForm.testnum" :min="0" :max="editForm.incomnum" :precision="2" label="描述文字" @change="calculatePass"></el-input-number>
                </el-form-item>
                <el-form-item label="合格数量" prop="passnum">
                  <el-input-number v-model="editForm.passnum" :min="0" :max="editForm.testnum" label="描述文字" :precision="2" @change="calculatePass"></el-input-number>
                </el-form-item>
                <el-form-item label="合格率" prop="passrate">
                  <el-input v-model="editForm.passrate" disabled style="width: 130px" placeholder="请输入内容" :precision="2">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
                <el-form-item v-if="editForm.testnum-editForm.passnum>0" label="不良类别" prop="rawBadInfo">
                  <el-select
                    v-model="editForm.rawBadInfo"
                    multiple
                    filterable
                    default-first-option
                    style="width: 100%"
                    placeholder="请选择或自定义不良类别"
                    @change="changeRawBadtype"
                  >
                    <el-option
                      v-for="item in rawBadType"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="editForm.rawBad.length>0&&editForm.testnum-editForm.passnum>0">
                  <el-row v-for="item in editForm.rawBad" :key="item.key" style="margin-bottom: 10px">
                    <el-col :span="14" style="padding-right: 6px">
                      <el-form-item>
                        <el-input v-model="item.num" type="number" min="0" :step="0.01" :precision="2" onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/);this.dispatchEvent(new Event('input'))">
                          <template slot="prepend">{{ item.name }}</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="检验方式" prop="testtype">
                  <el-radio v-model="editForm.testtype" :label="2">免检</el-radio>
                  <el-radio v-model="editForm.testtype" :label="1">抽检</el-radio>
                  <el-radio v-model="editForm.testtype" :label="0">全检</el-radio>
                </el-form-item>
                <el-form-item label="判定" prop="deter">
                  <!--                  <el-radio v-model="editForm.deter" :label="1" @change="updateFormVerify">合格</el-radio>-->
                  <!--                  <el-radio v-model="editForm.deter" :label="0" @change="updateFormVerify">不合格</el-radio>-->
                  <el-radio v-model="editForm.deter" :label="1">合格</el-radio>
                  <el-radio v-model="editForm.deter" :label="0">不合格</el-radio>
                </el-form-item>
                <el-form-item label="检验员" prop="userid">
                  <UserSelect :key="num" v-model="editForm.userid" :set="editForm.oldid" :userid="user.dUserid"></UserSelect>
                </el-form-item>
                <el-form-item label="问题描述" prop="desc">
                  <el-input
                    v-model="editForm.desc"
                    type="textarea"
                    :rows="4"
                    placeholder="请输入内容"
                    maxlength="300"
                    show-word-limit
                  >
                  </el-input>
                </el-form-item>
                <el-form-item label="问题处理" prop="deal">
                  <el-input
                    v-model="editForm.deal"
                    type="textarea"
                    :rows="4"
                    placeholder="请输入内容"
                    maxlength="300"
                    show-word-limit
                  >
                  </el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                  <el-input
                    v-model="editForm.remark"
                    type="textarea"
                    :rows="4"
                    placeholder="请输入内容"
                    maxlength="300"
                    show-word-limit
                  >
                  </el-input>
                </el-form-item>
                <el-form-item style="text-align: right">
                  <el-button :loading="eidtLoading" type="primary" @click="SubForm('editForm')">立即提交</el-button>
                  <el-button @click="dialogVisible=false">取消</el-button>
                </el-form-item>

              </el-form>
            </div>
          </el-dialog>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>import { getUser } from '@/utils/auth'
import {
  exportRawLedgerList,
  getRawLedgerList,
  getRawTypeAll,
  geteRawBadtypeAll,
  updateAndaddRawLedger,
  selectByRlidRawBadInfo,
  deleteRawLedger
} from '@/api/erp'
import OrderChoose from '@/components/OrderChoose/index'
import qs from 'qs'
import UserSelect from '@/components/UserSelect/index'

export default {
  name: 'Ycltz',
  components: { UserSelect, OrderChoose },
  data() {
    return {
      num: null,
      deleteLoading: false,
      eidtLoading: false,
      dialogVisible: false,
      editTitle: '添加原材料台账',
      exportLoading: false,
      editFormLoading: false,
      searchForm: {
        search: '',
        opertime: []
      },
      loading: false,
      tableData: [],
      rawTypes: [],
      rawBadType: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editForm: {
        rlid: null,
        oldorderid: null,
        month: null,
        week: null,
        testtime: null,
        supplier: null,
        name: null,
        orderid: null,
        spec: null,
        unit: null,
        type: null,
        incomnum: 0,
        testnum: 0,
        passnum: 0,
        passrate: 0.00,
        testtype: 2,
        deter: 1,
        desc: null,
        deal: null,
        remark: null,
        rawBadInfo: [],
        rawBad: [],
        userid: null,
        oldid: null
      },
      editRules: {
        testtime: [{ required: true, message: '请选择日期', trigger: 'change' }],
        userid: [{ required: true, message: '请选择检验员', trigger: 'change' }],
        // orderid: [{ required: true, message: '请选择订单', trigger: 'change' }]
        // supplier: [{ required: true, message: '请在这里填写供应商', trigger: 'blur' }],
        // name: [{ required: true, message: '请在这里填写产品名称', trigger: 'blur' }],
        // spec: [{ required: true, message: '请在这里填写规格/型号', trigger: 'blur' }],
        // unit: [{ required: true, message: '请选择产品单位', trigger: 'change' }],
        type: [{ required: true, message: '请选择产品类别', trigger: 'change' }]
        // incomnum: [{ required: true, message: '不能为空', trigger: 'change' }],
        // testnum: [{ required: true, message: '不能为空', trigger: 'change' }],
        // passnum: [{ required: true, message: '不能为空', trigger: 'change' }],
        // passrate: [{ required: true, message: '不能为空', trigger: 'change' }],
        // testtype: [{ required: true, message: '不能为空', trigger: 'change' }],
        // deter: [{ required: false, message: '不能为空', trigger: 'change' }],
        // desc: [{ required: false, message: '请在这里填写问题描述', trigger: 'blur' }],
        // deal: [{ required: false, message: '请在这里填写问题处理', trigger: 'blur' }],
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
    this.getRawTypeAll()
    this.geteRawBadtypeAll()
  },
  methods: {
    deleteRow(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteLoading = true
        const data = {
          rlid: row.rlid,
          userid: this.user.dUserid,
          role: this.user.role,
          groupid: this.user.dGroupid
        }
        deleteRawLedger(data).then(response => {
          this.getData()
          this.deleteLoading = false
        }).catch(() => {
          this.deleteLoading = false
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    changeRawBadtype() {
      if (this.editForm.rawBadInfo.length > 0) {
        const _rawBad = []
        for (const c of this.editForm.rawBadInfo) {
          _rawBad.push({ name: c, num: 0 })
        }
        if (this.editForm.rawBad.length === 0) {
          this.editForm.rawBad = _rawBad
        } else {
          for (const a of _rawBad) {
            let _num = 0
            for (const b of this.editForm.rawBad) {
              if (a.name === b.name) {
                break
              }
              _num++
            }
            if (_num === this.editForm.rawBad.length) {
              this.editForm.rawBad.push(a)
            }
          }
          for (const b of this.editForm.rawBad) {
            let _num = 0
            for (const a of _rawBad) {
              if (b.name === a.name) {
                break
              }
              _num++
            }
            if (_num === _rawBad.length) {
              this.editForm.rawBad.splice(this.editForm.rawBad.indexOf(b), 1)
            }
          }
        }
      } else {
        this.editForm.rawBad = []
      }
    },
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        let startTime = ''
        let endTime = ''
        if (this.searchForm.opertime !== null && this.searchForm.opertime.length === 2) {
          startTime = this.searchForm.opertime[0]
          endTime = this.searchForm.opertime[1]
        }
        const data = {
          content: this.searchForm.search,
          userid: this.user.dUserid,
          role: this.user.role,
          groupid: this.user.dGroupid,
          startTime: startTime,
          endTime: endTime
        }
        this.$message({
          message: '数据正在导出，请稍候'
        })
        exportRawLedgerList(data).then(response => {
          this.exportLoading = false
          const _this = this
          const xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              const blob = this.response
              const a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    editRow(row) {
      // this.editFormLoading = true
      this.dialogVisible = true
      if (row === null) {
        this.editTitle = '添加原材料台账'
        this.editForm.rlid = null
        this.editForm.month = null
        this.editForm.week = null
        this.editForm.testtime = null
        this.editForm.supplier = null
        this.editForm.name = null
        this.editForm.orderid = null
        this.editForm.oldorderid = null
        this.editForm.spec = null
        this.editForm.unit = null
        this.editForm.type = null
        this.editForm.incomnum = 0
        this.editForm.testnum = 0
        this.editForm.passnum = 0
        this.editForm.passrate = 0.00
        this.editForm.testtype = 2
        this.editForm.deter = 1
        this.editForm.desc = null
        this.editForm.deal = null
        this.editForm.remark = null
        this.editForm.rawBadInfo = []
        this.editForm.rawBad = []
        this.editForm.userid = null
        this.editForm.oldid = null
        this.num = new Date().getTime()
        // this.updateFormVerify()
      } else {
        this.editTitle = '编辑原材料台账'
        this.editForm.rlid = row.rlid
        this.editForm.month = row.month
        this.editForm.week = row.week
        this.editForm.testtime = row.testtime
        this.editForm.supplier = row.supplier
        this.editForm.name = row.name
        this.editForm.oldorderid = row.orderid
        this.editForm.orderid = null
        this.editForm.spec = row.spec
        this.editForm.unit = row.unit
        this.editForm.type = row.type
        this.editForm.incomnum = row.incomnum
        this.editForm.testnum = row.testnum
        this.editForm.passnum = row.passnum
        this.editForm.passrate = row.passrate
        this.editForm.testtype = row.testtype
        this.editForm.deter = row.deter
        this.editForm.desc = row.desc
        this.editForm.deal = row.deal
        this.editForm.remark = row.remark
        this.editForm.rawBadInfo = []
        this.editForm.rawBad = []
        this.editForm.userid = null
        this.editForm.oldid = row.userid
        this.num = new Date().getTime()
        // this.updateFormVerify()
        const data = {
          rlid: row.rlid
        }
        selectByRlidRawBadInfo(data).then(response => {
          const _data = response.data
          for (var i = 0; i < _data.length; i++) {
            this.editForm.rawBadInfo.push(_data[i].name)
            this.editForm.rawBad.push(_data[i])
          }
        })
      }
    },
    SubForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.eidtLoading = true
          var str = this.editForm.testtime
          str = str.replace(/[^\d]/g, '/')
          var date = new Date(str)
          this.editForm.month = date.getMonth() + 1 + ''
          this.editForm.week = ((date - (new Date(date.getFullYear() + '-01-01'))) / (24 * 60 * 60 * 7 * 1000) | 0) + 1
          const data = {
            rlid: this.editForm.rlid,
            month: this.editForm.month,
            week: this.editForm.week,
            testtime: this.editForm.testtime,
            supplier: this.editForm.supplier,
            name: this.editForm.name,
            orderid: this.editForm.orderid,
            spec: this.editForm.spec,
            unit: this.editForm.unit,
            type: this.editForm.type,
            incomnum: this.editForm.incomnum,
            testnum: this.editForm.testnum,
            passnum: this.editForm.passnum,
            passrate: this.editForm.passrate,
            testtype: this.editForm.testtype,
            deter: this.editForm.deter,
            desc: this.editForm.desc,
            deal: this.editForm.deal,
            remark: this.editForm.remark,
            userid: this.editForm.userid,
            rawBad: qs.parse(this.editForm.rawBad)
          }
          updateAndaddRawLedger(data).then(response => {
            this.getData()
            this.eidtLoading = false
            this.dialogVisible = false
            this.$message.success('提交成功')
          }).catch(() => {
            this.eidtLoading = false
            this.$message.error('提交失败')
          })
        } else {
          return false
        }
      })
    },
    calculatePass() {
      if (this.editForm.testnum > this.editForm.incomnum) {
        this.editForm.testnum = this.editForm.incomnum
      }
      if (this.editForm.passnum > this.editForm.testnum) {
        this.editForm.passnum = this.editForm.testnum
      }
      if (this.editForm.passnum !== 0 && this.editForm.passnum !== null && this.editForm.passnum !== undefined) {
        this.editForm.passrate = (this.editForm.passnum / this.editForm.testnum * 100).toFixed(2)
      } else {
        this.editForm.passrate = 0.00
      }
      if (this.editForm.passnum === this.editForm.testnum) {
        this.editForm.rawBadInfo = []
        this.editForm.rawBad = []
      }
    },
    getData() {
      this.loading = true
      let startTime = ''
      let endTime = ''
      if (this.searchForm.opertime !== null && this.searchForm.opertime.length === 2) {
        startTime = this.searchForm.opertime[0]
        endTime = this.searchForm.opertime[1]
      }
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        role: this.user.role,
        groupid: this.user.dGroupid,
        startTime: startTime,
        endTime: endTime
      }
      getRawLedgerList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    getRawTypeAll() {
      getRawTypeAll().then(response => {
        this.rawTypes = response.data
      })
    },
    geteRawBadtypeAll() {
      geteRawBadtypeAll().then(response => {
        this.rawBadType = response.data
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.fldy-container {
.tcf-row{
  .card{
    .card-body{
      .card-title{
        .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
          .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
            &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
            &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
          .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
      .card-content{
        .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
            &:hover{
                color:#409EFF;
              }
            }
          }
        .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
        .el-table::before{
            height: 0!important;
          }
        .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
